export default __webpack_public_path__ + "static/media/sales.d9905d75.svg";